import { adjustFontSize, findIndexByProperty, removeElement } from "./Common.js";
import { ModalFX } from "./Modal.js";
import { initTokatsu } from "./TokatsuSystem.js";

export const setButton = () => {
  const FNP_CD = document.querySelector(`[name="FNP_CD"]`).value;
  console.log(`setButton FNP_CD`,FNP_CD);
  document.querySelectorAll(`[data-cd]`).forEach((v,k) => {
    v.classList.remove('is-active');
  });
  document.querySelector(`[data-cd="${FNP_CD}"]`).classList.add('is-active');
}
export const Plan = {
  props:{},
  async init(){
    if(!document.querySelector(`[name="FNP_CD"]`))return;
    this.props = {
      "param":{
        "plan":JSON.parse(document.querySelector(`[name="plan"]`).value),
      }
    };
    const response = await this.getRequest();
    console.log(response,this.props);
    const FNP_CD = document.querySelector(`[name="FNP_CD"]`).value;
    const plansHeader = document.getElementById('plans-header');
    plansHeader.innerHTML = this.Tabs(Object.values(this.props.FNPs));
    await this.procPlan(this.props,FNP_CD);
    await this.changePlan(this.props);
    //モーダルを開く
    var modalFX = ModalFX();
    modalFX.init();
    this.modalItems();
    const btnPrint = document.querySelector(`.btnPrint`);
    btnPrint.addEventListener('click',() => {
      this.btnPrintHandle();
    });
  },
  /**---------------------------------------------
   * 東葛システムから初期表示アイテムを取得
   * 同SLUG4プラン分を取得する
   * LS…各プラン毎のアイテムオプション
   * LS2…各プラン毎の初期表示アイテム
  **-----------------------------------------------*/
  async getRequest(){
    const url = `https://tokatsu-system.com/api/v1.1/tokatsu/plans/${this.props.param.plan.slug}`;
    const response = await axios.get(url,this.props.param);
    this.props.LS = response.data.res.LS;
    this.props.LS2 = response.data.res.LS2;
    this.props.FNPs = response.data.res.FNPs;
    return response;
  },
  insertBrBetweenJapaneseAndNumbers(text){
    // 正規表現で日本語と数字の間に改行タグを挿入
    return text.replace(/([ぁ-んァ-ヶ一-龠])(\d)/g, '$1<br>$2')
    .replace(/(\d)([ぁ-んァ-ヶ一-龠])/g, '$1<br>$2');
  },
  Tabs(FNPs){
    // console.log(FNPs);
    return `${FNPs.map((v,k)=>{
      const FNP_CD = document.querySelector(`[name="FNP_CD"]`).value;
      const isActive = FNP_CD == v.FNP_CD?' is-active':'';
      return `<div data-cd="${v.FNP_CD}" class="plan px-2 py-2 mx-3 has-text-centered is-size-7${isActive}">${this.insertBrBetweenJapaneseAndNumbers(v.FNP_name_short)}</div>`
    }).join(``)}`
  },
  async TagIncludes(){
    const init = await initTokatsu();
    const FNP_CD = document.querySelector(`[name="FNP_CD"]`).value;
    const arr = init.TAGs[FNP_CD]
    return `${arr.map(v=>{
      return `<div><span class="tag">${v}</span></div>`
    }).join(``)}`;
  },
  async procPlan(props, FNP_CD){
    const PL = {...props.FNPs[FNP_CD], ...props.param.plan};
    console.log(`PL`,PL);
    const dataNames = document.querySelectorAll(`[data-name]`);
    dataNames.forEach((v,k) => {
      const dataName = v.getAttribute('data-name');
      const dataValue = PL[dataName]?PL[dataName]:'';
      v.innerHTML = dataValue;
    });
    const features = {
      isMessage: "花ことばに合わせた<br>祭壇カラーが選べます",
      isPoint: "祭壇生花のポイント<br>カラーが選べます",
      isSaidan: "祭壇生花の<br>カラーが選べます",
    };
    const saidan = document.getElementById('saidan');
    // サブ要素のテンプレートを返す関数
    function renderFeature(key, label, imagePrefix) {
      const value = PL[key];
      if (value === '0') return '';
      console.log(value);
      return `
        <div class="flower-feature">
          <div class="feature-comment">${features[label]}</div>
          <div>
            <figure class="image-1by2">
              <img src="/assets/image/${imagePrefix}${value}.webp" alt="">
            </figure>
          </div>
        </div>
      `;
    }
    saidan.innerHTML = `
      <img class="saidan" src="/assets/image/plan${PL.FNP_CD}.webp" alt="">
    `;
    document.querySelectorAll(`.flower-feature`).forEach((v,k) => {
      v.remove();
    });

    saidan.insertAdjacentHTML('afterend',renderFeature('is_message', 'isMessage', 'message'));
    saidan.insertAdjacentHTML('afterend',renderFeature('is_pointcolor', 'isPoint', 'saidan'));
    saidan.insertAdjacentHTML('afterend',renderFeature('is_saidancolor', 'isSaidan', 'saidan'));

    const planItemList = document.getElementById('plan-item-list');
    // プランアイコンリスト
    const itemList = props.LS2[FNP_CD];
    planItemList.innerHTML = itemList.map((v,k) => {
      return `<div class="modal-button" data-item="${v.item_CD}" data-category="${v.category_CD}" data-target="plan_image_modal">
            <i class="ph ph-arrows-out"></i>
            <figure class="image-1by1">
              <img src="/assets/image/${v.item_CD}.webp" alt="" class="src">
            </figure>
            <p class="has-text-centered is-size-7 item_name">${v.name_HP}</p>
          </div>`;
    }).join(``);

    /**---------------------------------------------
     * タグの追加　暫定
    **-----------------------------------------------*/
    const tagIncludes = document.getElementById('tag-includes');
    tagIncludes.innerHTML = await this.TagIncludes();

    document.querySelectorAll(`.adjust`).forEach((v,k) => {
      adjustFontSize(v,102,true);
    });

  },
  async changePlan(props){
    const btns = document.querySelectorAll(`[data-cd]`);
    btns.forEach((v,k) => {
      v.addEventListener('click',(e)=>{
        btns.forEach((v2,k2) => {
          v2.classList.remove('is-active');
        });
        const FNP_CD = e.target.getAttribute('data-cd');
        v.classList.add('is-active');
        document.querySelector(`[name="FNP_CD"]`).value = FNP_CD;
        //プラン内容の書き換え
        this.procPlan(props,FNP_CD);
        //モーダルの初期化
        var modalFX = ModalFX();
        modalFX.init();
        this.modalItems();
      });
    });
  },
  async initSwiper(initialIndex = 0){
    return new Promise((resolve) => {
      setTimeout(() => {
        const slides = document.querySelectorAll(`#gallery-thumnail .swiper-slide`);
        const loopMode = slides.length > 4;
        const loopMode2 = slides.length > 1;
        const swiper = new Swiper("#gallery-thumnail", {
          loop: loopMode,
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
        });

        const swiper2 = new Swiper("#gallery", {
          initialSlide: initialIndex,
          slidesPerView: 1,
          spaceBetween: 10,
          loop: loopMode2,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: swiper,
          }
        });
        swiper.update();
        swiper2.update();
        /**---------------------------------------------
         * Slideギミック
        **-----------------------------------------------*/
        resolve({ swiper, swiper2 });
      }, 0);
    })

  },
  test(data,swiper){
    console.log(swiper);

    // console.log(`data`,data);
    swiper.on('slideChangeTransitionEnd',()=>{
      //console.log(`swiper`,swiper);
      const currentSlide = swiper.slides[swiper.activeIndex];
      //console.log(`currentSlide`, currentSlide);
      const param = {
        "item_CD": currentSlide.getAttribute('data-item'),
        "category_CD": currentSlide.getAttribute('data-category'),
        "item_name": currentSlide.querySelector('p').textContent,
      }
      //console.log(`param`, param);
      const itemList = document.getElementById(`plan-item-list`);
      const div = itemList.querySelector(`[data-category="${param.category_CD}"]`);
      div.setAttribute('data-item', param.item_CD);
      div.querySelector(`img`).src = `/assets/image/${param.item_CD}.webp`;
      div.querySelector(`p`).textContent = param.item_name;
    });
  },

  async modalItems(){
    const planItemList = document.getElementById('plan-item-list');
    const modals = planItemList.querySelectorAll(`[data-item]`);
    modals.forEach((v,k) => {
      v.addEventListener('click',async (e)=>{
        console.log(v);


        const data = {
          "item_CD":v.getAttribute('data-item'),
          "category_CD":v.getAttribute('data-category'),
          "FNP_CD":document.querySelector(`[name="FNP_CD"]`).value,
        };

        // console.log(`props, data, LS2`,props,data,props.LS[data.FNP_CD][data.category_CD]);

        //すべてのアイテムリスト
        const LS = this.props.LS[data.FNP_CD][data.category_CD]
        console.log(`itemOptions LS`,LS);
        const swiperInitialIndex = findIndexByProperty(LS,'item_CD',data.item_CD);

        //初期値のグレードより前の要素を削除したリスト
        //console.log(`swiperInitialIndex`,swiperInitialIndex,LS);

        const grade = LS[swiperInitialIndex]?LS[swiperInitialIndex].estimate_grade:1;
        //console.log(`grade`,grade);

        const filterByGrade = (items, grade) => {
          return items.filter(item => item.estimate_grade === grade);
        };

        //const gradeLS = removeElementsBeforeIndex(LS,swiperInitialIndex);
        const gradeLS = filterByGrade(LS,grade);
        const swiperInitialIndexGrade = findIndexByProperty(gradeLS,'item_CD',data.item_CD);

        // console.log(`gradeLS`,gradeLS);
        document.getElementById('gallery').innerHTML = this.swipeItems(gradeLS);
        document.getElementById('gallery-thumnail').innerHTML = this.swipeThumnails(gradeLS);

        //さらに表示するボタンの表示非表示
        if(gradeLS.length != LS.length){
          document.getElementById('gallery-more').classList.remove('is-hidden');
        }else{
          document.getElementById('gallery-more').classList.add('is-hidden');
        }

        /**---------------------------------------------
         * swiperの初期化前にイベントリスナーを削除する
         * ※２回目以降のさらに表示する処理で、
         * swiperのpagenationが機能しない不具合対応
        **-----------------------------------------------*/
        const galleryMoreBtn = document.getElementById('gallery-more');
        const newGalleryMoreBtn = galleryMoreBtn.cloneNode(true);
        galleryMoreBtn.parentNode.replaceChild(newGalleryMoreBtn, galleryMoreBtn);

        //『さらに表示する』ボタン処理
        // swiper, swiper2変数を先に宣言して再代入
        let swiper
        let swiper2
        ({swiper, swiper2} = await this.initSwiper(swiperInitialIndexGrade));
        document.getElementById('gallery-more').addEventListener('click',async(e) => {
          const swiperActiveIndex = swiper2.activeIndex;
          console.log(`swiperActiveIndex`,swiperActiveIndex);
          const activeItemCD = gradeLS[swiperActiveIndex].item_CD;
          document.getElementById('gallery').innerHTML = this.swipeItems(LS);
          document.getElementById('gallery-thumnail').innerHTML = this.swipeThumnails(LS);
          const swiperInitialIndex = findIndexByProperty(LS,'item_CD',activeItemCD);
          ({swiper, swiper2} = await this.initSwiper(swiperInitialIndex))
          document.getElementById('gallery-more').classList.add('is-hidden');
          //slideGimmick(swiper.swiper2,data);
          this.test(data,swiper2);
        });
      });
    });
  },
  swipeItems(LS){
    return `<div class="swiper-wrapper">
            ${LS.map(v=>{
              return `<div class="swiper-slide" data-item="${v.item_CD}" data-category="${v.category_CD}">
              <figure class="image-1by1">
                <picture>
                  <source srcset="/assets/image/${v.item_CD}.webp" type="image/webp">
                  <img src="/assets/image/${v.item_CD}.png" alt="${v.name_HP}" class="src">
                </picture>
              </figure>
              <p class="is-size-7">${v.name_HP}</p>
            </div>`
            }).join(``)}
          </div>
          <div class="swiper-pagination"></div>
          `;
  },
  swipeThumnails(LS){
    return `<div class="swiper-wrapper">
            ${LS.map(v=>{
              return `<div class="swiper-slide">
              <figure class="image-1by1">
                <picture>
                  <source srcset="/assets/image/${v.item_CD}.webp" type="image/webp">
                  <img src="/assets/image/${v.item_CD}.png" alt="" class="src">
                </picture>
              </figure>
            </div>`
            }).join(``)}
          </div>`
  },

  btnPrintHandle(){
    const plan = JSON.parse(document.querySelector(`[name="plan"]`).value);
    const data = {
      "FNP_CD": document.querySelector(`[name="FNP_CD"]`).value,
      "FNP_slug": document.querySelector(`[name="FNP_slug"]`).value,
      "intro": document.querySelector(`[data-name="intro"]`).innerHTML,
      "FNP_name": document.querySelector(`[data-name="FNP_name"]`).innerHTML,
      "FNP_price_exc_short": document.querySelector(`[data-name="FNP_price_exc_short"]`).innerHTML,
      "FNP_price_inc_short": document.querySelector(`[data-name="FNP_price_inc_short"]`).innerHTML,
      "FNP_summary": document.querySelector(`[data-name="FNP_summary"]`).innerHTML,
      "name":plan.name,
      "name_e":plan.name_e,
      "items":[],
      "tags":[],
    }
    const items = document.querySelectorAll(`#plan-item-list .modal-button`);
    items.forEach((v,k) => {
      data.items.push({
        "item_CD":v.getAttribute('data-item'),
        "item_name":v.querySelector(`.item_name`).innerHTML,
      });
    });
    const tags = document.querySelectorAll(`#tag-includes .tag`);
    tags.forEach((v,k) => {
      data.tags.push(v.innerHTML);
    });
    console.log(`printData`,data);
     // セッションストレージに保存
    sessionStorage.setItem('extractedContent',  JSON.stringify(data));
    // 新しいウィンドウを開く
    window.open('/targetPrint', '_blank');
  }
}
